import ChallengeSearch from './ChallengeSearch';

export default ChallengeSearch;
